export default "__VITE_ASSET__bf5827a3__"